// Feature switches shared by the app and the prerenderer (scripts/prerender.mjs).
//
// SHOW_CONFIGURATOR_LINKS: when false the door configurator is "unlisted" —
//   no nav/hero/product-page links, noindex and out of the sitemap — but the
//   direct URL /configurator (and /et/configurator) keeps working.
export const SHOW_CONFIGURATOR_LINKS = false;
